<footer>
    <div>
        <div *ngIf="showCouncilSupportEmail" class="support-email-footer">
            <strong>Help?</strong> For technical support, please contact JJR IT Support <a href="mailto:councilvideosupport@jjrichards.com.au"><span class="badge">JJR Council Video Portal Support (councilvideosupport@jjrichards.com.au)</span></a>
        </div>
        <div *ngIf="showJjrSupportEmail" class="support-email-footer">
            For technical support, please contact JJR IT Support <a href="mailto:servicedesk@jjrichards.com.au"><span class="badge">servicedesk@jjrichards.com.au</span></a>
        </div>

        <hr />

        <div>
            {{ productName }} <span *ngIf="environment">({{ environment }})</span> v{{ version }} &copy; JJ’s Waste & Recycling 2017&ndash;{{ year }}
        </div>
        <div>
            Usage of this portal is governed by the <a #termsAndConditionsButton routerLink="/terms-and-conditions" ng-reflect-router-link="terms-and-conditions" href="/terms-and-conditions">terms and conditions here</a>
        </div>
    </div>
</footer>
